import React, { useState, useEffect } from 'react';
import v from '../../../../utils/Verifiers.jsx';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import CloseButton from '../../../sharecomponents/CloseButton';
import AutoCompleteInput from '../../../sharecomponents/AutocompleteImput';
import { dateFormatConDiaYHoraShort } from '../../../../utils/DateFunctions.jsx';
import { getUser } from '../../../../utils/Common.js';
import etiqImg from '../../../../assets/etiqueta.png';
import EtiiquetasBarCodePDF from '../../../templates/EtiiquetasBarCodePDF.jsx';
import { set } from 'lodash';

const AgregarOrdenesTrabajo = (p) => {
    const close = p.close ?? (() => { });
    var today = ((new Date()).getDay() - 1);
    today = today < 0 ? 5 : today;
    const [selecciones, setselecciones] = useState({
        usuario: null,
        nuevo_usuario: null,
        plan_siembra: p.plan_siembra ?? -1,
        dia: today,
        charolas: 0
    });
    const [totales, settotales] = useState({ total_planeado: -1, total_asignado: -1, total_dia: -1, asignado_dia: -1 });
    const [planes, setplanes] = useState(v.getLS('planes_trabajo'));
    const [usuarios, setusuarios] = useState(v.getLS('usuarios_labores'));
    const [loader, setloader] = useState(false);
    const [detallesOrdenesTrabajo, setdetallesOrdenesTrabajo] = useState({});
    const [generadorEtiqeustas, setgeneradorEtiqeustas] = useState(null);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const dias = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO'];
    const usuarioLabor = (getUser()?.perfil?.nombre ?? '').toUpperCase() === 'EJECUCION DE LABORES';
    const perfilEditor = ['EJECUCION DE LABORES', 'USUARIO', 'VIVERO', 'ADMINSITRADOR', 'SIEMBRA VIVERO'].includes((getUser()?.perfil?.nombre ?? '').toUpperCase());
    const [charolas_hora, setcharolas_hora] = useState(null);

    useEffect(() => {
        if (selecciones.plan_siembra >= 0) {
            cambiarBloque(selecciones.plan_siembra);
        }
        setselecciones({ ...selecciones, dia: selecciones.dia });
        ajustarListaUsuarios(today);
    }, []);


    const selectUser = (value) => {
        let normalized = v.text_normalice(value, true);

        if (usuarios.includes(normalized)) {
            setselecciones({ ...selecciones, usuario: normalized, nuevo_usuario: null });
        } else {
            setselecciones({ ...selecciones, usuario: null, nuevo_usuario: normalized });
        }
    }

    const cambiarBloque = (index) => {
        setselecciones({ ...selecciones, plan_siembra: index });
        if (index < 0) {
            setdetallesOrdenesTrabajo({});
            return;
        }
        getDetallesOrdenesTrabajo(planes[index].plan_cosecha_id, index);
    }

    const switchTarea = async (ids, activeLoader = false) => {
        if (!perfilEditor) return;
        let resp = await v.getDataAPI('ordenes_trabajo/siembra/switch/multi', { ordenes_ids: ids }, activeLoader ? setloader : false, setdialog);
        if (!resp) return;
        setdetallesOrdenesTrabajo(procesarDiasDataDetalles(resp.detalles));
        v.saveLS('planes_trabajo', resp.planes.planes);
        setplanes(resp.planes.planes);
    }

    const ajustarListaUsuarios = (dia_seleccion = selecciones.dia) => {
        const dias = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO', "DOMINGO"];
        const asistencias_semana = v.getLS('usuarios_asistencias') ?? { "LUNES": [], "MARTES": [], "MIERCOLES": [], "JUEVES": [], "VIERNES": [], "SABADO": [], "DOMINGO": [] };
        const dia = dias[dia_seleccion];
        setusuarios(asistencias_semana[dia] ?? []);
    }



    const eliminarTarea = async (id) => {
        if (usuarioLabor) return;
        let resp = await v.getDataAPI('ordenes_trabajo/siembra/delete', { id }, setloader, setdialog);
        if (!resp) return;
        setdetallesOrdenesTrabajo(procesarDiasDataDetalles(resp.detalles));
        v.saveLS('planes_trabajo', resp.planes.planes);
        setplanes(resp.planes.planes);
    }

    const agregarTareas = async () => {
        let args = {
            plan_cosecha_id: planes[selecciones.plan_siembra].plan_cosecha_id,
            asignado_a: selecciones.usuario ?? selecciones.nuevo_usuario,
            dia: selecciones.dia,
            charolas: selecciones.charolas
        }
        let resp = await v.getDataAPI('ordenes_trabajo/siembra/add', args, setloader, setdialog);
        if (!resp) return;
        setdetallesOrdenesTrabajo(procesarDiasDataDetalles(resp.detalles));
        v.saveLS('planes_trabajo', resp.planes.planes);
        setplanes(resp.planes.planes);
        getNombresLaboradores();
        setselecciones({ ...selecciones, charolas: 0, usuario: null, nuevo_usuario: null });
        document.getElementById("laborador-input").value = "";
    }

    /**
        * Obtiene la lista de usuarios que pueden recibir asignaciones y actualiza el localstorage para que estén diponible al abrir la sección
        * @returns {void}
        */
    const getNombresLaboradores = async () => {
        if (usuarioLabor) return;
        let resp = await v.getDataAPI('/ordenes_trabajo/usuarios', {}, false, false);
        if (!resp.estatus) return;
        v.saveLS('usuarios_labores', resp.data);
        setusuarios(resp.data);
    }

    const getDetallesOrdenesTrabajo = async (plan_cosecha_id, index) => {
        let resp = await v.getDataAPI('ordenes_trabajo/siembra/detalles', { plan_cosecha_id }, setloader, setdialog);
        if (!resp) {
            setdetallesOrdenesTrabajo({});
            setselecciones({ ...selecciones, total_planeado: -1, total_asignado: -1 });
            return;
        }
        setcharolas_hora(resp.charolas_hora);
        let detallesProcesados = procesarDiasDataDetalles(resp.data);
        setdetallesOrdenesTrabajo(detallesProcesados);
        v.scrollAnimacion('diaSeccion' + selecciones.dia, 500, "containerOrdenesTrabajo");
    }

    const detallesTotales = (detalles = { ...detallesOrdenesTrabajo }) => {
        let index_plan = selecciones.plan_siembra;
        let index_dia = selecciones.dia;
        if (index_plan < 0) {
            return { total_planeado: -1, total_asignado: -1, total_dia: -1, asignado_dia: -1 };
        }
        let planBloque = planes[index_plan];
        let total_planeado = 0;
        let total_asignado = !detalles || Object.keys(detalles) === 0 ? -1 : 0;
        let total_dia = 0;
        let asignado_dia = 0;
        for (let i = 0; i < 6; i++) {
            total_planeado += planBloque[dias[i].toLowerCase() + '_plan'];
            if (total_asignado === -1) continue;
            let usuariosDia = Object.keys(detalles[dias[i]] ?? {});
            if (i === index_dia) total_dia = planBloque[dias[i].toLowerCase() + '_plan'];
            for (let j = 0; j < usuariosDia.length; j++) {
                total_asignado += detalles[dias[i]][usuariosDia[j]].length;
                if (i === index_dia) {
                    asignado_dia += detalles[dias[i]][usuariosDia[j]].length;
                }
            }
        }
        let nuevosTotales = { total_planeado, total_asignado, total_dia, asignado_dia };
        return nuevosTotales;
    }

    const procesarDiasDataDetalles = (data) => {
        let formatData = JSON.parse(JSON.stringify(data));
        for (let i = 0; i < dias.length; i++) {
            if (Array.isArray(data[dias[i]]) && data[dias[i]].length === 0) formatData[dias[i]] = {};
            else formatData[dias[i]] = data[dias[i]];

        }
        return formatData;
    }

    const diaLista = (dia, i) => {
        let usuarios = detallesOrdenesTrabajo[dia] ?? {};
        let usuariosNombres = Object.keys(usuarios);
        let componente = null;
        let total_asignado = 0;
        if (usuariosNombres.length > 0) {
            componente = usuariosNombres.map((usuario, i) => listaTrabajoUsuario(usuario, usuarios[usuario], dia, i));
            for (let i = 0; i < usuariosNombres.length; i++) {
                total_asignado += usuarios[usuariosNombres[i]].length;
            }
        } else {

        }

        let total_planeado = planes[selecciones.plan_siembra][`${dia.toLowerCase()}_plan`];
        return (
            <div key={v.keyGen()} className='w-100' id={'diaSeccion' + i}>
                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <div className='w-100 text-start text-bold text-l border-bottom mt-4'>
                        {dia}
                        <span className='ms-2 text-start text-s text-bold text-300'>Plan x día:<span className='text-bold ms-1'>{total_planeado} ch.</span></span>
                        <span className='ms-2 text-start text-s text-bold text-300'>Asignado:<span className='text-bold ms-1'>{total_asignado} ch.</span></span>
                        {total_asignado <= 0 && total_planeado > 0 && <span className='ms-2 text-bold text-start text-s text-bold text-red3'>No hay ordenes de trabajo</span>}
                        {total_asignado > total_planeado && <span className='ms-2 text-start text-bold text-s text-bold text-blue3'>Excedente de asignaciones</span>}
                    </div>
                    {componente}
                </div>
            </div>
        );
    }

    const listaTrabajoUsuario = (usuario, datos, dia, i) => {
        let detalles = datos.map((registro, j) => trabajoDetalle(registro));
        return (
            <div className='row justify-content-end p-0 m-0 w-100' key={v.keyGen()}>
                <div className='bw-1200'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className={`w-100 text-start text-bold text-s border-bottom ${i > 0 ? 'mt-3' : 'mt-1'} mb-1`}>
                            {usuario}
                            <span className='opacity-60 ms-3'>{datos.length} charolas</span>
                            <span className='opacity-60 ms-3'>{charolas_hora && charolas_hora > 0 ? +(datos.length / charolas_hora).toFixed(1) : "-"} Horas</span>
                            <button className='btn btn-sm p-0 bw-200 border m-1 btn-dark text-bold shadow' onClick={() => {

                                const faltantes = datos.filter(d => !d.fecha_realizado).map(d => d.id);
                                if (faltantes.length === 0) {
                                    v.activeDialog(setdialog, `No hay tareas pendientes por marcar como realizadas para ${usuario}.`, 'INFORMACIÓN', 'error');
                                    return;
                                }
                                switchTarea(faltantes, true);
                            }}>(usuario) Marcar todo realizado</button>
                            {detalles}
                        </div>
                    </div>
                </div>
            </div >
        );
    }

    const trabajoDetalle = (registro) => {
        let eliminable = (!registro.fecha_realizado && registro.impreso == "NO");
        return (
            <div className='bw-1100 bg-light round-s shadow-sm mb-2 border p-1' key={v.keyGen()}>
                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <div className={`bw-250 text-center text-300 text-s border round-s text-white 
                    ${perfilEditor && !registro.fecha_realizado ? 'pointer scale-025' : ''}
                    bg-${registro.fecha_realizado ? 'green4' : 'red4'}`}
                        onClick={() => { if (registro.fecha_realizado) return; switchTarea([registro.id]) }}
                    >
                        {registro.fecha_realizado ? 'Realizado' : 'Estado'}:

                        <span className='text-bold text-s ms-1'>{
                            registro.fecha_realizado ? dateFormatConDiaYHoraShort(registro.fecha_realizado, 'pendiente') : 'No realizado'
                        }</span>
                    </div>
                    <div className='bw-100 text-center text-s'>Fol. <span className='text-bold ms-1'>{registro.id}</span></div>
                    <div className='bw-250 text-s text-center'>Asignado <span className='text-bold ms-1'>{dateFormatConDiaYHoraShort(registro.fecha_asignacion, 'No definda')}</span></div>
                    <div className='bw-200 text-s text-center'>Asignado por <span className='text-bold ms-1'>{registro.asignado_por}</span></div>
                    {!usuarioLabor && <div
                        className={`m-0 p-0 bg-white shadow contenedor ${!registro.fecha_realizado ? 'pointer scale-05' : 'opacity-30'}`}
                        style={{ width: '20px', height: '20px' }}
                        disabled={eliminable ? false : true}
                        onClick={() => { if (registro.fecha_realizado) return; eliminarTarea(registro.id); }}>
                        <div className={`w-100`}>❌</div>
                    </div>}
                    <div className={`m-0 p-0 bg-white shadow contenedor ${registro.impreso == "NO" ? 'opacity-30' : ''}`} style={{ width: '20px', height: '20px' }}>
                        <img src={etiqImg} style={{ height: "20px", width: "100%" }} />
                    </div>
                </div>
            </div>
        );
    }

    const selectorDeBloques = () => {
        return (<div className='bw-250 mt-1'>
            <div className='w-100 text-bold text-s ps-2 text-start'>SELECCIONE UN BLOQUE</div>
            <select
                className={`form-control round-s form-control-sm border border-2 shadow-sm ${selecciones.plan_siembra < 0 ? '' : 'border-success'}`}
                value={selecciones.plan_siembra}
                onChange={(e) => cambiarBloque(v.numberFormat(e.target.value, -1))}>
                <option value={-1} >SELECCIONE UNO</option>
                {
                    planes.map((plan, i) => <option key={v.keyGen()} value={i} >{plan.bloque}</option>)
                }
            </select>
        </div>)
    }

    const selectorDia = () => {
        return (<div className='bw-150 mt-1'>
            <div className='w-100 text-bold text-s ps-2 text-start'>SELECCIONE UN DÍA</div>
            <select
                className={'form-control round-s form-control-sm border border-2 shadow-sm ' + (usuarioLabor ? '' : 'border-success')}
                value={selecciones.dia}
                onChange={(e) => {
                    let dia = v.numberFormat(e.target.value, 0);
                    setselecciones({ ...selecciones, dia, charolas: 0 });
                    ajustarListaUsuarios(dia);
                    v.scrollAnimacion('diaSeccion' + dia, 100, "containerOrdenesTrabajo");
                }}>
                {
                    dias.map((dia, i) => <option key={v.keyGen()} value={i} >{dia}</option>)
                }
            </select>
        </div>);
    }

    const panelAdminAgregarOrdenesTrabajo = () => {
        if (usuarioLabor) return null;
        return (<div className='w-100 round-s bg-light border p-1 pb-2 shadow mb-2'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 text-center text-300 text-l mb-1 mt-0 p-0'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {!charolas_hora && <div className='col-auto text-bold ms-1 me-1'>Agregar actividades</div>}
                        {charolas_hora && <div className='col-auto ms-1 me-1 text-s p-1 round-m border border-warning bg-white'>
                            Rendimiento:<span className='text-bold ms-1'>{charolas_hora}</span> x hora
                            <span className='text-bold ms-2'>{charolas_hora * 8}</span> x día
                        </div>}
                        {detallesTotales().total_dia > -1 && <div className='col-auto ms-1 me-1'>Total {dias[selecciones.dia].toLowerCase()}<span className='text-bold ms-1'>{detallesTotales().total_dia}</span> </div>}
                        {detallesTotales().asignado_dia > -1 && <div className='col-auto ms-1 me-1'>Asignado {dias[selecciones.dia].toLowerCase()}<span className='text-bold ms-1'>{detallesTotales().asignado_dia}</span> </div>}
                        {detallesTotales().total_planeado > -1 && <div className='col-auto ms-1 me-1 opacity-50'>Total semana<span className='text-bold ms-1'>{detallesTotales().total_planeado}</span> </div>}
                        {detallesTotales().total_asignado > -1 && <div className='col-auto ms-1 me-1 opacity-50'>Asignado semana<span className='text-bold ms-1'>{detallesTotales().total_asignado}</span> </div>}

                    </div>
                </div>
                <AutoCompleteInput
                    label='SELECCIONE UN USUARIO'
                    inputClass={' round-s form-control-sm border border-2 shadow text-center contenedor ' + (!selecciones.usuario ? '' : 'border border-success border-2')}
                    text_class="text-bold ps-2 w-100 text-s text-start"
                    id="laborador-input"
                    match={usuarios}
                    function={selectUser}
                />
                {selectorDeBloques()}
                {selectorDia()}
                <div className='bw-150 mt-1'>
                    <div className='w-100 text-bold text-s ps-2 text-start'>CHAROLAS</div>
                    <input type='numberic' step={1}
                        className={`form-control round-s form-control-sm border border-2 shadow-sm ${selecciones.charolas <= 0 ? '' : 'border-success'}`}
                        value={selecciones.charolas}
                        onChange={(e) => {
                            let charolas = Math.abs(Math.round(v.numberFormat(e.target.value, 0)));
                            let totales = detallesTotales();
                            let faltante = totales.total_dia - totales.asignado_dia;
                            if (faltante <= 0) charolas = 0;
                            else if (charolas > faltante) charolas = faltante;
                            setselecciones({ ...selecciones, charolas: charolas });
                        }}
                    />
                </div>
                <div className='bw-200 mt-1'>
                    <div className='w-100 text-bold text-s ps-2 text-start'>
                        {((!selecciones.usuario && !selecciones.nuevo_usuario) || selecciones.plan_siembra < 0 || selecciones.charolas <= 0) ? "COMPLETE LAS SELECCIONES" : "LISTO PARA ASIGNAR"}
                    </div>
                    <button className='btn btn-light border border-warning round-xxl border-3 shadow w-100 p-0 text-bold'
                        disabled={(!selecciones.usuario && !selecciones.nuevo_usuario) || selecciones.plan_siembra < 0 || selecciones.charolas <= 0}
                        onClick={agregarTareas}
                    >Agregar tareas</button>
                </div>
            </div>
        </div>);
    }

    const panelaboradorSelecciones = () => {
        if (!usuarioLabor) return null;
        return (<div className='w-100 bg-white4 blur-xl shadow-sm border p-1' style={{ position: "sticky", top: 0, zIndex: 2 }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                {selectorDeBloques()} {selectorDia()}
            </div>
        </div>);
    }
    return (
        <div className='vh-100 vw-100 blur-xl bg-white5' style={v.floatPageStyle()}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <CloseButton
                    close={close}
                    containerStyle='w-100 pt-0 pb-0 text-end pe-2'
                    buttonStyle='bw-150 btn btn-sm btn-danger mb bg-red3 mt-2 shadow ps-3 pe-3 scale-continue-05 border border-warning border-3 text-bold round-xxl' />

                <div className='bw-1300 bg-white shadow-multi p-1 round-s'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 h4 text-300 text-center mb-0 p-0 bg-black text-white round-xs'>EDITOR DE ORDENES DE TRABAJO</div>
                        {panelAdminAgregarOrdenesTrabajo()}
                        <div className='w-100 m-0 p-0' style={{ height: usuarioLabor ? '86vh' : "74vh", overflow: "auto" }} id="containerOrdenesTrabajo">
                            {panelaboradorSelecciones()}
                            <button className='btn btn-sm p-0 bw-350 border m-1 btn-dark text-bold shadow' onClick={() => {
                                const ords = [];
                                dias.map(dia => {
                                    const ordenesDia = detallesOrdenesTrabajo[dia] ?? {};
                                    const usuariosDia = Object.keys(ordenesDia);
                                    usuariosDia.map(usuario => ordenesDia[usuario].map(orden => {
                                        if (!orden.fecha_realizado) ords.push(orden.id);
                                    }));
                                });
                                if (ords.length === 0) {
                                    v.activeDialog(setdialog, `No hay tareas pendientes por marcar como realizadas para esta semana.`, 'INFORMACIÓN', 'error');
                                    return;
                                }
                                switchTarea(ords, true);
                            }}>
                                Realizar todas las ordenes de la semana
                            </button>
                            {selecciones.plan_siembra > -1 && dias.map((dia, i) => diaLista(dia, i))}
                            {selecciones.plan_siembra < 0 && <div className='w-100 text-center text-bold h4 mt-5 text-300'>Seleccione un bloque para ver las ordenes de trabajo</div>}
                        </div>
                    </div>

                </div>
            </div>
            <VainillaDialog data={dialog} />
            {generadorEtiqeustas && <EtiiquetasBarCodePDF />}
            {loader && ldr}
        </div>
    )
}

export default AgregarOrdenesTrabajo;